<!-- Share and Assign Modal -->
<div class="modal-header gtm-share-assign selenium-share-assign">
    <h5
        *ngIf="isAssignAvailable"
        class="modal-title selenium-share-assign-title"
    >
        Assign or Share
    </h5>
    <h5
        *ngIf="!isAssignAvailable"
        class="modal-title selenium-share-assign-title"
    >
        Share
    </h5>
    <button
        type="button"
        class="close selenium-share-assign-close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="sections">
        <div
            class="section-wrapper"
            *ngIf="isAssignAvailable"
            [ngClass]="{ 'first-section': isAssignAvailable }"
        >
            <div class="section-title">Assign this resource:</div>
            <div class="actions">
                <div
                    class="action"
                    [ngClass]="{ active: selectedAction.assign }"
                >
                    <div
                        *ngIf="isAssignAvailable"
                        class="selenium-share-assign-class"
                        (click)="assignToClass()"
                    >
                        <div class="icon-wrapper">
                            <app-icon
                                type="AssignClass"
                                class="assign-class-icon"
                            ></app-icon>
                        </div>
                        <p class="tab-title-text">Assign to Class</p>
                    </div>
                </div>

                <div
                    class="action"
                    [ngClass]="{ active: selectedAction.quickAssign }"
                    (click)="onClickAssignCode()"
                >
                    <div
                        *ngIf="isAssignAvailable"
                        class="selenium-share-assign-code"
                    >
                        <div class="icon-wrapper">
                            <app-icon type="Code" class="code-icon"></app-icon>
                        </div>
                        <p class="assign-code-text tab-title-text">
                            Quick Assign
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="content mobile-content">
            <div
                *ngIf="isResourceUnassignable() && !selectedAction.social"
                class="not-available"
            >
                <p>{{ notAvailableText }}</p>
            </div>

            <div
                *ngIf="isResourceAssignable() && selectedAction.quickAssign"
                class="container assign-code-container"
            >
                <div class="row center-text">
                    <p class="student-site-text">
                        Have students enter this code on the
                        <a
                            href="/student"
                            target="_blank"
                            rel="noopener noreferrer"
                            >student site</a
                        >:
                    </p>
                </div>
                <div class="row center-text">
                    <h2 class="activity-code">
                        {{ activityData.activity.code }}
                    </h2>
                </div>
                <div class="row center-text">
                    <p>or share this link with them</p>
                </div>
                <div class="row center-text">
                    <div class="copy-link-wrapper">
                        <input
                            type="text"
                            [(ngModel)]="activityData.activity.student_url"
                            class="assign-code-url"
                            id="assignCodeUrlMobile"
                        />
                        <app-button
                            class="copy-link-btn"
                            (click)="copyLinkByElementId('assignCodeUrlMobile')"
                            >Copy Link</app-button
                        >
                    </div>
                </div>
            </div>
        </div>

        <div class="section-wrapper">
            <div class="section-title" *ngIf="isAssignAvailable">
                Or share it with anyone:
            </div>
            <div class="section-title" *ngIf="!isAssignAvailable">
                You can share this collection now:
            </div>

            <div class="actions">
                <div
                    class="action"
                    *ngIf="!isAssignAvailable"
                    [ngClass]="{ active: selectedAction.codeLink }"
                >
                    <div
                        class="selenium-share-link"
                        (click)="onClickShareLink()"
                    >
                        <div class="icon-wrapper">
                            <app-icon type="Link" class="link-icon"></app-icon>
                        </div>
                        <p class="assign-code-text tab-title-text">
                            Share Link
                        </p>
                    </div>
                </div>

                <div class="action">
                    <div
                        class="selenium-share-assign-remind"
                        (click)="onClickRemind($event)"
                    >
                        <div class="icon-wrapper">
                            <img
                                class="remind-icon"
                                [src]="remindImage"
                                alt="Share on Remind"
                            />
                        </div>
                        <p class="remind-text tab-title-text">Remind</p>
                    </div>
                </div>

                <div class="action addthis_share">
                    <span
                        class="addthis_share_button"
                        data-service="email"
                        (click)="onClickEmail()"
                    ></span>
                    <span class="selenium-share-assign-email">
                        <div class="icon-wrapper">
                            <app-icon
                                class="email-icon"
                                [type]="'Email'"
                            ></app-icon>
                        </div>
                        <p class="tab-title-text">Email</p>
                    </span>
                </div>

                <div
                    class="action"
                    [ngClass]="{ active: selectedAction.social }"
                    (click)="onClickSocial()"
                >
                    <div class="selenium-share-assign-social">
                        <div class="icon-wrapper">
                            <app-icon
                                type="SocialMedia"
                                class="social-icon-icon"
                            ></app-icon>
                        </div>
                        <p class="social-media-text tab-title-text">
                            Social Media
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="content">
        <div
            *ngIf="isResourceUnassignable() && !selectedAction.social"
            class="not-available"
        >
            <p>{{ notAvailableText }}</p>
        </div>

        <div
            *ngIf="isResourceAssignable() && selectedAction.quickAssign"
            class="container assign-code-container"
        >
            <div class="row center-text">
                <p class="student-site-text">
                    Have students enter this code on the
                    <a href="/student" target="_blank" rel="noopener noreferrer"
                        >student site</a
                    >:
                </p>
            </div>
            <div class="row center-text">
                <h2 class="activity-code">{{ activityData.activity.code }}</h2>
            </div>
            <div class="row center-text">
                <p>or share this link with them</p>
            </div>
            <div class="row center-text">
                <div class="copy-link-wrapper">
                    <input
                        type="text"
                        [(ngModel)]="activityData.activity.student_url"
                        class="assign-code-url"
                        id="assignCodeUrl"
                    />
                    <app-button
                        class="copy-link-btn"
                        (click)="copyLinkByElementId('assignCodeUrl')"
                        >Copy Link</app-button
                    >
                </div>
            </div>
        </div>

        <div *ngIf="selectedAction.social" class="addthis_share">
            <span
                class="addthis_share_button icon fab fa-pinterest fa-lg pinterest-icon-any"
                data-service="pinterest_share"
            ></span>
            <span
                class="addthis_share_button icon fab fa-twitter fa-lg twitter-icon-any"
                data-service="twitter"
            ></span>
            <span
                class="addthis_share_button icon facebook-icon-any fab fa-facebook fa-lg"
                data-service="facebook"
            ></span>
        </div>

        <div
            class="container assign-code-container"
            *ngIf="selectedAction.codeLink"
        >
            <div class="row center-text">
                <div class="copy-link-wrapper">
                    <input
                        type="text"
                        [(ngModel)]="shareLink"
                        class="assign-code-url"
                        id="shareCodeUrl"
                    />
                    <app-button
                        class="copy-link-btn"
                        (click)="copyLinkByElementId('shareCodeUrl')"
                        >Copy Link</app-button
                    >
                </div>
            </div>
        </div>
    </div>

    <p *ngIf="isAssignAvailable && !isResourceUnAssignable" class="details">
        Or
        <a (click)="clickUseLessonBuilder($event)" href="#"
            >use our Lesson Builder Tool</a
        >
        to add instructions or discussion questions to this resource.
    </p>
</div>
